var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00439 10.6762H10.6762",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00439 14.0132H8.67399",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00439 17.3502H8.67399",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0088 22.022H3.3348C2.98079 22.022 2.64128 21.8813 2.39095 21.631C2.14063 21.3807 2 21.0412 2 20.6872V6.67179C2 6.31778 2.14063 5.97827 2.39095 5.72795C2.64128 5.47763 2.98079 5.337 3.3348 5.337H6.67179C6.67179 4.45197 7.02337 3.60319 7.64918 2.97738C8.27499 2.35158 9.12376 2 10.0088 2C10.8938 2 11.7426 2.35158 12.3684 2.97738C12.9942 3.60319 13.3458 4.45197 13.3458 5.337H16.6828C17.0368 5.337 17.3763 5.47763 17.6266 5.72795C17.8769 5.97827 18.0176 6.31778 18.0176 6.67179V8.67399",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0087 4.66959C10.0747 4.66959 10.1393 4.68916 10.1941 4.72582C10.249 4.76249 10.2918 4.81461 10.317 4.87558C10.3423 4.93656 10.3489 5.00366 10.336 5.06839C10.3232 5.13312 10.2914 5.19258 10.2447 5.23925C10.198 5.28592 10.1386 5.3177 10.0739 5.33057C10.0091 5.34345 9.94202 5.33684 9.88105 5.31158C9.82007 5.28633 9.76795 5.24356 9.73129 5.18868C9.69462 5.1338 9.67505 5.06929 9.67505 5.00329C9.67505 4.91478 9.71021 4.82991 9.77279 4.76732C9.83537 4.70474 9.92025 4.66959 10.0087 4.66959",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.511 16.25C17.9607 16.25 19.136 15.0747 19.136 13.625C19.136 12.1753 17.9607 11 16.511 11C15.0612 11 13.886 12.1753 13.886 13.625C13.886 15.0747 15.0612 16.25 16.511 16.25Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.011 21.5C12.011 20.3065 12.4851 19.1619 13.329 18.318C14.1729 17.4741 15.3175 17 16.511 17C17.7045 17 18.8491 17.4741 19.693 18.318C20.5369 19.1619 21.011 20.3065 21.011 21.5H12.011Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestor);
export default __webpack_public_path__ + "static/media/requestor.dc9a5591.svg";
export { ForwardRef as ReactComponent };